import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { Cstipi } from '../model/cstipi.model';

@Injectable()
export class CstIpiService extends EntityService<Cstipi> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'cstipi',
      urlBackend: configService.backendURL
    });
  }
}
